export default __webpack_public_path__ + "static/media/union.cf34bb75.svg";